/* AP — "Beden seçilmeden sepete eklenmesin" davranışı.
   Tema ilk bedeni (en küçük) otomatik seçili getirir ve formdaki varyantı ona ayarlar.
   Biz TEMANIN İÇ DURUMUNA DOKUNMAYIZ (varyant, URL, piksel olayları aynen kalır); yalnızca:
   - ziyaretçi bedene tıklayana kadar bedenleri "seçili değil" gösteririz,
   - sepete ekle / hemen öde düğmesini "Beden Seçimi Yapınız" yaparız ve gönderimi engelleriz,
   - düğmeye basılırsa beden alanını ekranın ortasına kaydırıp vurgularız.
   ?variant= ile açılan sayfalar (reklam, sepet, favori bağlantısı) zaten bilinçli seçimdir → dokunulmaz. */
(function () {
  'use strict';
  if (window.__apBeden) { return; }
  window.__apBeden = true;
  var DIL = (document.documentElement.lang || 'tr').slice(0, 2).toLowerCase();
  var TR = DIL === 'tr';
  var MET = { tr: ['Beden Seçin', 'Sepete eklemek için lütfen bir beden seçin.', 'Beden'], en: ['Select a size', 'Please choose a size to add to your cart.', 'Size'],
    de: ['Größe wählen', 'Bitte eine Größe wählen, um den Artikel in den Warenkorb zu legen.', 'Größe'], it: ['Seleziona la misura', 'Seleziona una misura per aggiungere l\u2019articolo al carrello.', 'Misura'],
    nl: ['Kies een maat', 'Kies een maat om het artikel aan je winkelwagen toe te voegen.', 'Maat'], ro: ['Alege mărimea', 'Alege o mărime pentru a adăuga produsul în coș.', 'Mărime'],
    el: ['Επιλέξτε μέγεθος', 'Επιλέξτε μέγεθος για να προσθέσετε το προϊόν στο καλάθι.', 'Μέγεθος'], ru: ['Выберите размер', 'Выберите размер, чтобы добавить товар в корзину.', 'Размер'] };
  var MM = MET[DIL] || MET.en;
  var METIN = MM[0];
  var UYARI = MM[1];
  var BEDEN = /^(beden|size|numara|bed|größe|grösse|taglia|misura|maat|mărime|marime|μέγεθος|размер|eu size)$/i;
  var AZALT = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var KAYITLI = [];   // { W, kok, secildi }

  function bedenSelect(W) {
    var sel = W.querySelectorAll('select[name^="options["]');
    for (var i = 0; i < sel.length; i++) {
      var ad = (sel[i].name.match(/^options\[(.*)\]$/) || [])[1] || '';
      if (BEDEN.test(ad.trim())) { return sel[i]; }
    }
    return null;
  }
  function kokBul(W) {
    var n = W;
    while (n && n !== document.documentElement) {
      if (n.querySelector && n.querySelector('[data-add-to-cart]')) { return n; }
      n = n.parentElement;
    }
    return null;
  }
  function kayit(W) { for (var i = 0; i < KAYITLI.length; i++) { if (KAYITLI[i].W === W) { return KAYITLI[i]; } } return null; }
  function kayitBul(el) { for (var i = 0; i < KAYITLI.length; i++) { if (KAYITLI[i].kok.contains(el)) { return KAYITLI[i]; } } return null; }

  function metinleriBas(k) {
    var spans = k.kok.querySelectorAll('[data-add-to-cart-text]');
    Array.prototype.forEach.call(spans, function (s) { if (s.textContent !== METIN) { k.kendiYazdi = true; s.textContent = METIN; } });
    Array.prototype.forEach.call(k.kok.querySelectorAll('[data-add-to-cart]'), function (b) {
      b.classList.add('ap-beden-bekliyor'); b.setAttribute('aria-label', METIN);
    });
  }
  function metinleriBirak(k) {
    Array.prototype.forEach.call(k.kok.querySelectorAll('[data-add-to-cart]'), function (b) {
      b.classList.remove('ap-beden-bekliyor');
      var s = b.querySelector('[data-add-to-cart-text]');
      var yeni = b.disabled ? (b.getAttribute('data-lang-sold-out') || (s && s.textContent)) : b.getAttribute('data-lang-available');
      if (s && yeni) { s.textContent = yeni; }
      if (yeni) { b.setAttribute('aria-label', yeni); }
    });
  }
  function gorselSifirla(k) {
    var sel = bedenSelect(k.W); if (!sel) { return; }
    var idx = sel.getAttribute('data-index') || '';
    var chips = k.W.querySelectorAll('[data-product-option="' + idx + '"] .product__chip.selected');
    k.sifirlaniyor = true;
    Array.prototype.forEach.call(chips, function (c) { c.classList.remove('selected'); c.removeAttribute('aria-pressed'); });
    k.sifirlaniyor = false;
    k.W.setAttribute('data-ap-beden-yok', '');
  }
  function secildi(k) {
    if (k.secildi) { return; }
    k.secildi = true;
    k.W.removeAttribute('data-ap-beden-yok');
    var u = k.W.querySelector('.ap-beden-uyari'); if (u) { u.remove(); }
    // tema kendi durumunu güncelledikten sonra düğme metnini sıfırla
    setTimeout(function () { metinleriBirak(k); }, 0);
    setTimeout(function () { metinleriBirak(k); }, 250);
    setTimeout(function () { stickyEsitle(k); }, 300);
  }

  function odakla(k) {
    var hedef = k.W.querySelector('[data-product-option]') || k.W;
    var kutu = hedef.closest('.product__controls-group') || hedef;
    var r = kutu.getBoundingClientRect();
    var y = r.top + (window.pageYOffset || 0) - (window.innerHeight / 2 - r.height / 2);
    window.scrollTo({ top: Math.max(0, y), behavior: AZALT ? 'auto' : 'smooth' });
    kutu.classList.remove('ap-beden-vurgu'); void kutu.offsetWidth; kutu.classList.add('ap-beden-vurgu');
    if (!k.W.querySelector('.ap-beden-uyari')) {
      var p = document.createElement('p'); p.className = 'ap-beden-uyari'; p.setAttribute('role', 'alert'); p.textContent = UYARI;
      (hedef.parentNode || k.W).insertBefore(p, hedef.nextSibling);
    }
    setTimeout(function () {
      var c = k.W.querySelector('.product__chip:not([disabled])'); if (c && c.focus) { c.focus({ preventScroll: true }); }
    }, AZALT ? 0 : 450);
  }

  function engelle(e) {
    var t = e.target; if (!t || !t.closest) { return; }
    var tetik = t.closest('[data-add-to-cart], .shopify-payment-button, shopify-accelerated-checkout, [data-shopify="payment-button"]');
    var form = e.type === 'submit' ? t : null;
    var k = tetik ? kayitBul(tetik) : (form ? kayitBul(form) : null);
    if (!k || k.secildi) { return; }
    if (e.type === 'submit' && !(form.querySelector && form.querySelector('[data-add-to-cart]')) && !(form.action && /\/cart\/add/.test(form.action))) { return; }
    e.preventDefault(); e.stopImmediatePropagation();
    odakla(k);
  }
  ['click', 'submit', 'keydown'].forEach(function (olay) {
    document.addEventListener(olay, function (e) {
      if (e.type === 'keydown' && !(e.key === 'Enter' || e.key === ' ')) { return; }
      engelle(e);
    }, true);
  });


  // ---- Yapışkan sepet çubuğunda beden kutucukları (ana chip'lerin aynası; tıklama ANA chip'e iletilir → tema/piksel aynı yolu izler)
  function chipDisabled(c) {
    return c.disabled || c.getAttribute('aria-disabled') === 'true' || /unavail|sold|disabled|out-of/i.test(c.className);
  }
  function stickyEsitle(k) {
    if (!k.stickyRow) { return; }
    var main = k.W.querySelectorAll('[data-product-option="' + k.idx + '"] .product__chip');
    Array.prototype.forEach.call(k.stickyRow.querySelectorAll('.ap-sticky-chip'), function (s) {
      var m = null;
      Array.prototype.forEach.call(main, function (c) { if (c.getAttribute('data-option-value') === s.getAttribute('data-value')) { m = c; } });
      var sel = !!(m && k.secildi && m.classList.contains('selected'));
      s.classList.toggle('ap-secili', sel); s.setAttribute('aria-pressed', sel ? 'true' : 'false');
      var dis = !m || chipDisabled(m); s.classList.toggle('ap-pasif', dis);
    });
  }
  function stickyKur(k) {
    var meta = k.kok.querySelector('.sticky-atc-bar__meta'); if (!meta || k.stickyRow) { return; }
    var sel = bedenSelect(k.W); k.idx = sel.getAttribute('data-index') || '';
    var main = k.W.querySelectorAll('[data-product-option="' + k.idx + '"] .product__chip'); if (!main.length) { return; }
    var row = document.createElement('div'); row.className = 'ap-sticky-bedenler'; row.setAttribute('role', 'group'); row.setAttribute('aria-label', MM[2]);
    Array.prototype.forEach.call(main, function (c) {
      var b = document.createElement('button'); b.type = 'button'; b.className = 'ap-sticky-chip';
      b.setAttribute('data-value', c.getAttribute('data-option-value')); b.textContent = c.getAttribute('data-option-value');
      b.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        if (b.classList.contains('ap-pasif')) { return; }
        var hedef = null;
        Array.prototype.forEach.call(k.W.querySelectorAll('[data-product-option="' + k.idx + '"] .product__chip'), function (c2) { if (c2.getAttribute('data-option-value') === b.getAttribute('data-value')) { hedef = c2; } });
        if (hedef) { hedef.click(); }
        setTimeout(function () { stickyEsitle(k); }, 60); setTimeout(function () { stickyEsitle(k); }, 400);
      });
      row.appendChild(b);
    });
    meta.appendChild(row); meta.classList.add('ap-sticky-bedenli'); k.stickyRow = row;
    new MutationObserver(function () { stickyEsitle(k); }).observe(k.W, { subtree: true, attributes: true, attributeFilter: ['class', 'disabled', 'aria-disabled'] });
    sel.addEventListener('change', function () { setTimeout(function () { stickyEsitle(k); }, 30); });
    stickyEsitle(k);
  }

  function baslat(W) {
    if (kayit(W)) { return; }
    var sel = bedenSelect(W); if (!sel) { return; }
    var kok = kokBul(W); if (!kok) { return; }
    var k = { W: W, kok: kok, secildi: false };
    var ana = !!document.querySelector('main [data-product-form], main .product-form') && document.querySelectorAll('.product__variants-wrapper').length === 1;
    if (ana && /[?&]variant=\d+/.test(location.search)) { k.secildi = true; }
    // tek bedenli / hepsi tükenmiş ürünlerde müdahale yok
    var secenek = sel.querySelectorAll('option').length;
    var butonlar = kok.querySelectorAll('[data-add-to-cart]');
    var hepsiPasif = true; Array.prototype.forEach.call(butonlar, function (b) { if (!b.disabled) { hepsiPasif = false; } });
    if (secenek < 2 || hepsiPasif) { k.secildi = true; }
    KAYITLI.push(k);
    stickyKur(k);
    if (k.secildi) { return; }

    gorselSifirla(k); metinleriBas(k);
    // tema yeniden "selected" ya da düğme metni yazarsa geri al
    new MutationObserver(function (list) {
      if (k.secildi) { return; }
      if (k.sifirlaniyor) { return; }
      var degisti = false;
      list.forEach(function (m) {
        if (m.type === 'attributes' && m.target.classList && m.target.classList.contains('selected') && m.target.closest('.product__variants-wrapper') === W) { degisti = true; }
        if (m.type === 'characterData' || m.type === 'childList') { degisti = true; }
      });
      if (degisti) { gorselSifirla(k); metinleriBas(k); }
    }).observe(kok, { subtree: true, attributes: true, attributeFilter: ['class'], characterData: true, childList: true });

    // ziyaretçi seçince: tıklama (zincir) ya da select değişimi
    W.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.product__chip, .product__swatch, label, [data-option-value]')) { secildi(k); }
    }, false);
    sel.addEventListener('change', function (e) { if (e.isTrusted) { secildi(k); } });
  }

  function tara() {
    Array.prototype.forEach.call(document.querySelectorAll('.product__variants-wrapper'), baslat);
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function () { setTimeout(tara, 150); }); }
  else { setTimeout(tara, 150); }
  var bekle = false;
  new MutationObserver(function () {
    if (bekle) { return; } bekle = true;
    requestAnimationFrame(function () { bekle = false; tara(); });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
